var $10e6c2290c1e9251$exports = {};
$10e6c2290c1e9251$exports = {
    "loading": `Laster inn ...`,
    "placeholder": `Velg \u{2026}`
};


export {$10e6c2290c1e9251$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
